import Description from './Description';
import Modal from './Modal';
import Title from './Title';

Modal.Description = Description;
Modal.Title = Title;

export default Modal;
